class ConditionSearchValidationModel {
    constructor(
        private _constraintsError: string = "",
        private _isError: boolean = false
    ) {}
    set constraintsError(value: string) {
        this._constraintsError = value
    }
    get constraintsError(): string {
        return this._constraintsError
    }
    set isError(value: boolean) {
        this._isError = value;
    }
    get isError(): boolean {
        return this._isError
    }
}
export default ConditionSearchValidationModel